import { getArrayFromCacheOrFromEndpoint } from "../../utilities/cacheValidator";
import { ICompanyCode, getCompanyCodesFromEndpoint } from "./storeRequests";
import { IUserProviderState } from "../UserContext";
import { APIAnomalyError } from "../../services/ErrorHelpers";

export async function getCompanyCodes(getTokenFn: () => Promise<any>): Promise<ICompanyCode[]> {
  const companyCodes = await getArrayFromCacheOrFromEndpoint<ICompanyCode[]>(
    "CompanyCodes",
    getCompanyCodesFromEndpoint,
    getTokenFn
  );
  return companyCodes;
}

export async function fetchAndParseCompanyCodes(getTokenFn: IUserProviderState["accessToken"]): Promise<string[]> {
  const companyCode = await getCompanyCodes(getTokenFn);
  if (companyCode.length === 0) {
    throw new APIAnomalyError("Received empty Array for Company Codes");
  }
  const codes = companyCode.reduce((ctr, item) => {
    const friendlyName = `${item.glCompanyCode} ${item.glCompanyName}`;
    if (!friendlyName.includes("INACTIVE")) {
      ctr.push(friendlyName);
    }
    return ctr;
  }, [] as string[]);
  return codes;
}
